import usuario from './usuario';
import perfil from './perfil';
import instituicao from './instituicao';
import orgao from './orgao';
import ambiente from './ambiente';
import modulo from './modulo';
import controlador from './controlador';
import permissao from './permissao';
import menu from './menu';
import pessoa from './pessoa';
import departamento from './departamento';
import configuracao from './configuracao';
import bairro from './bairro';
import logradouro from './logradouro';
import estados from './estados';
import cgmEndereco from './cgm_endereco';

export default {
  menu,
  orgao,
  perfil,
  pessoa,
  modulo,
  usuario,
  ambiente,
  permissao,
  instituicao,
  controlador,
  departamento,
  configuracao,
  bairro,
  logradouro,
  estados,
  cgmEndereco,
};
